import React, { PureComponent } from 'react';
//import PropTypes from 'prop-types';

class ThGrid extends PureComponent {
    render() {
        return (
            <div align="center" className="panel panel-default" style={{
                padding: 10,
                borderRadius: 0,
                width: '100%',
                fontWeight: 'bold',
                marginBottom: 0,
                backgroundColor: '#21ADA8',
                color: 'white'
            }}>
                {this.props.children}
            </div>
        );
    }
}

ThGrid.propTypes = {

};

export default ThGrid;